import { identityProvidersService } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

export const fetchIdentityProvidersQuery = (companyId?: string, enabled = true) => ({
  queryKey: ['fetchIdentityProviders', companyId],
  queryFn: async () => {
    return identityProvidersService.fetchIdentityProviders(companyId || '');
  },
  enabled: !!companyId && enabled,
});

const useFetchIdentityProviders = (companyId?: string, enabled = true) => {
  return useQuery(fetchIdentityProvidersQuery(companyId, enabled));
};

export default useFetchIdentityProviders;
